import(/* webpackMode: "eager", webpackExports: ["SearchPage"] */ "/home/runner/work/33m2-front/33m2-front/src/pages/guest/search/ui/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebviewSearchPage"] */ "/home/runner/work/33m2-front/33m2-front/src/pages/guest/search/ui/webview-page.tsx");
